const RESIZE_DEBOUNCE_TIME = 150

// Debounce function to limit the rate at which a function is executed
function debounce(func, wait) {
  let timeout
  return function (...args) {
    const later = () => {
      timeout = null
      func.apply(this, args)
    }
    clearTimeout(timeout)
    timeout = setTimeout(later, wait)
  }
}

function adjustHeights() {
  const viewportWidth = window.innerWidth

  // Poll the page for all elements with [data-synced-height-slot] attribute
  const elements = document.querySelectorAll('[data-synced-height-slot]')

  // Extract unique slot numbers
  const slots = [...new Set(Array.from(elements).map(el => el.dataset.syncedHeightSlot))]

  // Iterate over each unique slot number
  slots.forEach(slot => {
    const slotElements = document.querySelectorAll(`[data-synced-height-slot="${slot}"]`)
    let maxHeight = 0

    slotElements.forEach(el => {
      el.style.height = 'auto' // Reset height to get natural height

      const style = window.getComputedStyle(el)
      const marginTop = parseFloat(style.marginTop)
      const marginBottom = parseFloat(style.marginBottom)
      const elementHeight = el.offsetHeight + marginTop + marginBottom

      const minBreakpoint = parseInt(el.dataset.syncedHeightMin, 10)
      const maxBreakpoint = parseInt(el.dataset.syncedHeightMax, 10)

      // Check if the viewport is within the allowed range
      if ((isNaN(minBreakpoint) || viewportWidth >= minBreakpoint) && (isNaN(maxBreakpoint) || viewportWidth <= maxBreakpoint)) {
        // Only update maxHeight if within breakpoints
        if (elementHeight > maxHeight) {
          maxHeight = elementHeight
        }
      } else {
        // If outside the allowed breakpoints, remove forced height
        el.style.height = 'auto'
      }
    })

    // Apply the maximum height only if within the allowed breakpoints
    slotElements.forEach(el => {
      const minBreakpoint = parseInt(el.dataset.syncedHeightMin, 10)
      const maxBreakpoint = parseInt(el.dataset.syncedHeightMax, 10)

      if ((isNaN(minBreakpoint) || viewportWidth >= minBreakpoint) && (isNaN(maxBreakpoint) || viewportWidth <= maxBreakpoint)) {
        el.style.height = `${maxHeight}px`
      } else {
        // If the height should be ignored, remove any forced height
        el.style.height = 'auto'
      }
    })
  })
}

// Debounced version of the adjustHeights function
const debouncedAdjustHeights = debounce(adjustHeights, RESIZE_DEBOUNCE_TIME)

// Add event listener for window resize to trigger the debounced adjustHeights function
window.addEventListener('resize', debouncedAdjustHeights)

// Initial height adjustment on load
adjustHeights()
